export enum QueryParam {
    EffectiveDate = 'effectiveDate',
    CustomerGroups = 'customerGroups',
}
